// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__NScbd","label":"Category_label__1gEqu","content":"Category_content__3mhz9","header":"Category_header__1EXqa","location":"Category_location__2CzwL"};